import {
  DISCONNECTED,
  UNANSWERED,
  DROPPED,
  PENDING,
  ENDED,
} from 'modules/common/constants/conversationStatuses';
import errorAction from 'shared/utils/errorAction';
import createAsyncAction from 'shared/utils/createAsyncAction';
import { addModal } from 'modules/messageSystem/actions/addModal';
import { addToast } from 'modules/messageSystem/actions/addToast';
import { handleOffline, onRestore } from 'modules/conference/actions/offlineHandlers';

import { clearModalQueue } from 'modules/messageSystem/actions/clearModalQueue';
import { MODAL_END_CONSULTATION } from 'modules/messageSystem/constants/modalCodes';
import { updateConversation } from 'modules/conference/actions/_newConversationActions/updateConversation';

import createAction from './';
import { stopCall, stopCallReconnectionFailed } from './videoConsultation';


export const STOP_CONSULTATION_LOCAL = createAction('STOP_CONSULTATION_LOCAL');
export const STOP_CONSULTATION = createAsyncAction(createAction('STOP_CONSULTATION'));
export const HIDE_FINISHED_CONSULTATION = createAction('HIDE_FINISHED_CONSULTATION');

export const hideFinishedConsultation = () => (dispatch) => {
  dispatch(stopCallReconnectionFailed());
  dispatch({ type: HIDE_FINISHED_CONSULTATION });
};


const stopConsultationSuccessFn = (status) => (dispatch) => {
  dispatch(clearModalQueue());
  dispatch(onRestore());
  return dispatch({
    type: STOP_CONSULTATION.success,
    payload: { status: status || 'DISCONNECTED' },
  });
};


export const stopConsultationLocal = ({ reconnectionFailed } = {}) => (dispatch) => {
  dispatch(clearModalQueue());
  dispatch({ type: STOP_CONSULTATION_LOCAL });

  return (reconnectionFailed || !navigator.onLine)
    ? dispatch(stopCallReconnectionFailed())
    : dispatch(stopCall());
};

export const stopConsultation = ({ consultationFailed = false, backgroundStopConsultation = false, status } = {}) => (dispatch, getState) => {
  const state = getState();
  const { reconnection } = state.conference.consultationLifecycle;
  const { currentConversation } = state.conference;

  if (!backgroundStopConsultation) dispatch({ type: STOP_CONSULTATION.pending });

  let conversationNewStatus = ENDED;
  if (['CREATED', 'CONNECTING'].includes(currentConversation.status)) conversationNewStatus = UNANSWERED;
  if (reconnection || backgroundStopConsultation) conversationNewStatus = DISCONNECTED;
  conversationNewStatus = status || conversationNewStatus;

  dispatch(stopCall());
  return dispatch(updateConversation(conversationNewStatus))
    .then(() => {
      dispatch(stopConsultationSuccessFn(conversationNewStatus));

      if (consultationFailed && !backgroundStopConsultation) {
        const message = { id: 'const.disconnected', defaultMessage: '** You\'ve been disconnected' };
        dispatch(addToast(
          'failure',
          'you-were-disconnected-toast',
          message, false, null, false, false, null,
          6000, 'video'));
      }
    })
    .catch((err) => {
      dispatch(errorAction(STOP_CONSULTATION.failure, err));
      dispatch(stopConsultationLocal({ reconnectionFailed: true }));
    });
};

export const stopConsultationAfterWSResponse = (status) => (dispatch) => {
  dispatch({ type: STOP_CONSULTATION.pending });

  return dispatch(stopCall())
    .then(() => dispatch(stopConsultationSuccessFn(status)));
};

export const stopConsultationReconnectionFailed = () => (dispatch) => {
  dispatch(stopConsultationLocal({ reconnectionFailed: true }))
    .then(() => {
      if (!navigator.onLine) {
        return dispatch(handleOffline());
      }

      return null;
    });
};

export const stopConsultationWithConfirmation = () => (dispatch, getState) => {
  const state = getState();
  const { currentConversation } = state.conference;
  const status = currentConversation.status === PENDING ? DROPPED : undefined;

  dispatch(
    addModal({
      testId: 'end-consultation-modal',
      typeId: MODAL_END_CONSULTATION,
      onOk: () => dispatch(stopConsultation({ status }))
        .then(() => {
          if (/RnUmmanu/.test(navigator.userAgent)) {
            window.ReactNativeWebView?.postMessage(JSON.stringify({
              action: 'STOP_CONSULTATION',
            }));
          }
        }),
    }),
  );
};

export const stopConsultationWithNoPatientAnswer = (status) => (dispatch) => {
  dispatch({ type: STOP_CONSULTATION.pending });

  return dispatch(stopCall())
    .then(() => dispatch(stopConsultationSuccessFn(status)))
    .catch((err) => dispatch(errorAction(STOP_CONSULTATION.failure, err)));
};
